import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "ta-c" };
const _hoisted_2 = ["title"];
const _hoisted_3 = {
    key: 0,
    class: "ta-c"
};
import { routeName } from '@/constants/routeName';
import vuexStore from '@/vuex-store';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import dateFormatType from '@/constants/dateFormatType';
import { isTodayTextColor, formatDate, } from '@/utils';
import { isToday } from 'date-fns';
import { prevData } from '@/pinia/distributorNotice';
import { pStore } from '@/pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    emits: ["onDelete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const router = useRouter();
        const isDistUser = computed(() => vuexStore.getters['user/isDistUser']);
        const to = () => {
            const { id } = props.item;
            return {
                name: routeName.DISTRIBUTOR_NOTICE_DETAIL,
                params: {
                    distributorNoticeId: id,
                },
            };
        };
        /**
         * 링크 클릭 핸들러
         */
        const handleClickLink = () => {
            // 현재 페이지네이션 번호 저장
            prevData.pageNumber = pStore.piniaDistributorNotice.filterOption.pageNumber;
        };
        /**
         * 삭제 핸들러
         */
        const handleClickDeleteBtn = () => {
            emits('onDelete', props.item.id);
        };
        /**
         * 수정 클릭 핸들러
         */
        const handleClickEditBtn = () => {
            const name = routeName.DISTRIBUTOR_NOTICE_EDIT;
            const value = {
                params: {
                    distributorNoticeId: props.item.id,
                },
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(`cy-item-${props.item.id}`)
            }, [
                _createElementVNode("td", null, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                        class: "cy-link",
                        to: to(),
                        onClick: _cache[0] || (_cache[0] = ($event) => (handleClickLink()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.item.title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("span", {
                        title: _unref(isToday)(props.item.createdAt) ? '빨강색은 오늘 등록된 글입니다.' : '',
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).FULL_DATE_MINUTE)), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
                ]),
                (isDistUser.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickEditBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-pencil-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-xs": true
                                }
                            ]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "cy-delete-btn ml-1",
                            onClick: handleClickDeleteBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(" mdi-trash-can-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [2]
                                }),
                                _cache[3] || (_cache[3] = _createTextVNode(" 삭제 "))
                            ]),
                            _: 1 /* STABLE */,
                            __: [3]
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-xs": true
                                }
                            ]
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
